import React, { useEffect, useState } from "react";
import s from "./style.module.scss";
import MyGift from "entities/MyGift";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";
import { GetTransactionBonuses } from "./api";

const MyGiftsList: React.FC = () => {
  const { user_info, auth_key } = useAppSelector(userSelect);

  const [bonuses, setBonuses] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [isLastPage, setIsLastPage] = useState(false);

  const fetchCompliments = () => {
    if (auth_key && user_info) {
      GetTransactionBonuses({
        auth_key,
        user_id: user_info.id,
        page,
      })
        .then((data) => {
          if (data.length === 0) setIsLastPage(true);
          setBonuses([...bonuses, ...data]);
          setPage((prev) => prev + 1);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (user_info && auth_key) {
      setIsLastPage(false);
      fetchCompliments();
    }
  }, [user_info, auth_key]);

  useEffect(() => {
    if (loading) {
      fetchCompliments();
    }
  }, [loading]);

  useEffect(() => {
    document.addEventListener("scroll", handleScroll);

    return () => document.removeEventListener("scroll", handleScroll);
  });

  const handleScroll = (e: any) => {
    if (
      e.target.documentElement.scrollHeight -
        (e.target.documentElement.scrollTop + window.innerHeight) <
        100 &&
      !isLastPage
    ) {
      setLoading(true);
    }
  };

  return (
    <section className={s.list}>
      <h1>Мои подарки</h1>

      <ul>
        {loading && bonuses?.length === 0 ? (
          <li className={s.title}>Загрузка...</li>
        ) : bonuses.length ? (
          bonuses.map((item: any, key: any) => <MyGift {...item} key={key} />)
        ) : (
          <li className={s.title}>Подарков нет</li>
        )}
      </ul>
    </section>
  );
};

export default MyGiftsList;
